<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  body{
    margin: 0 !important;
  }
#app{
  width: 100%;
  height: 100%;
}

  .swiper-pagination-bullet{
    background: #fff !important;
    border: 1px solid #000 !important;
    border-radius: 50% !important;
  }
  .my-bullet-active{
    background: #000 !important;
    opacity: 0.8;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue